import { ReactNode } from "react";

//STYLES
import styles from "./InfoMessage.module.scss";

//ASSETS
import infoIcon from "../../assets/images/icons/ui/states/alert-icon.svg";
import infoBlueIcon from "../../assets/icons/info-icon.svg";

interface Props {
  message: ReactNode;
  className?: string;
  variant?: "default" | "blue";
}

const InfoMessage = ({ message, className, variant = "default" }: Props) => {
  const { infoMessage } = styles;
  const icon = variant === "blue" ? infoBlueIcon : infoIcon;
  return (
    <div className={`${className ? className : ""}`}>
      <img src={icon} />
      <span className={infoMessage}>{message}</span>
    </div>
  );
};

export default InfoMessage;
